import styles from './EmailRequiredModal.module.css';
import { useNavigate } from 'react-router-dom';

const EmailRequiredModal = ({ onClose, t }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeBtn} onClick={onClose}>✕</button>
        <img src="/assets/subscriptions/star.png" alt="" width="40" height="40" />
        <h2 className={styles.title}>{t("email_required")}</h2>
        <p className={styles.subtitle}>
          {t("subscription_email_required_before_subscribe")}
        </p>
        <button className={styles.actionBtn} onClick={() => { onClose(); navigate("/my-account") }}>
          {t("add")}
        </button>
      </div>
    </div>
  );
};

export default EmailRequiredModal;